import { EvaluationReviews } from 'lib/common/EvaluationDetails';
import React from 'react';

const Evaluations = (props: any) => {
  const { selectedRequest } = props;
  return (
    <EvaluationReviews
      requestEntries={[
        {
          requestId: selectedRequest.firstQuote?.id ?? selectedRequest.id,
          requestType: 'factoring-request',
        },
        {
          requestId: selectedRequest.id,
          requestType: 'factoring-request-payers',
        },
      ]}
    />
  );
};

export default Evaluations;
